"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _Link = require("./Link.Styled");

var _reactRouterDom = require("react-router-dom");

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const Link = _ref => {
  let {
    href,
    text,
    onClick,
    className,
    newTab = false
  } = _ref;
  const navigate = (0, _reactRouterDom.useNavigate)();
  if (!text || typeof onClick !== 'function' && !href) return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);

  const trigger = e => {
    e.preventDefault();

    if (newTab) {
      window.open(href, '_blank').focus();
    } else {
      navigate(href);
    }
  };

  return /*#__PURE__*/_react.default.createElement(_Link.StyledLink, {
    href: href,
    onClick: onClick || trigger,
    className: className
  }, text);
};

var _default = Link;
exports.default = _default;